import { GetProgramDayForDayNumberType } from 'types/services/spring/GetProgramDayForDayNumber';
import { GetProgramDayForTodayType } from 'types/services/spring/GetProgramDayForToday';
import { ProgramDayMinType, ProgramDayType } from './programDays';
import {
	CHANGE_CURRENT_DAY,
	FLUSH_PROGRAM_DAYS,
	REQUEST_CALENDAR,
	REQUEST_CALENDAR_PROGRAM_DAY_TODOS_SUCCESS,
	REQUEST_CALENDAR_SUCCESS,
	REQUEST_CALENDAR_TODAY_SUCCESS,
	REQUEST_DAY_SUCCESS,
	REQUEST_MOVE_ITEM,
	REQUEST_TODAY_SUCCESS,
} from './programDays.actionTypes';

export const actionCreators = {
	doRequestCalendar: () => ({
		type: REQUEST_CALENDAR,
	}),
	doRequestCalendarSuccess: (calendar: ProgramDayType[]) => ({
		type: REQUEST_CALENDAR_SUCCESS,
		calendar,
	}),
	doRequestCalendarProgramDayTodosSuccess: (programDays: ProgramDayMinType[]) => ({
		type: REQUEST_CALENDAR_PROGRAM_DAY_TODOS_SUCCESS,
		programDays,
	}),

	doRequestCalendarTodaySuccess: (calendarToday: Object) => ({
		type: REQUEST_CALENDAR_TODAY_SUCCESS,
		calendarToday,
	}),

	doRequestTodaySuccess: (day: GetProgramDayForTodayType) => ({
		type: REQUEST_TODAY_SUCCESS,
		day,
	}),

	doRequestDaySuccess: (day: GetProgramDayForDayNumberType) => ({
		type: REQUEST_DAY_SUCCESS,
		day,
	}),

	doChangeCurrentDay: (dayNumber?: any[]) => ({
		type: CHANGE_CURRENT_DAY,
		dayNumber,
	}),

	doFlushProgramDays: () => ({
		type: FLUSH_PROGRAM_DAYS,
	}),

	doMoveItem: ({
		programItemId,
		dayId,
		dayNumber,
		days,
	}: {
		programItemId: number;
		dayId: number;
		dayNumber: number;
		days: number;
	}) => ({
		type: REQUEST_MOVE_ITEM,
		programItemId,
		dayId,
		dayNumber,
		days,
	}),
};

export type ProgramDaysActionType =
	| ReturnType<typeof actionCreators.doRequestCalendar>
	| ReturnType<typeof actionCreators.doRequestCalendarSuccess>
	| ReturnType<typeof actionCreators.doRequestCalendarProgramDayTodosSuccess>
	| ReturnType<typeof actionCreators.doRequestCalendarTodaySuccess>
	| ReturnType<typeof actionCreators.doRequestTodaySuccess>
	| ReturnType<typeof actionCreators.doRequestDaySuccess>
	| ReturnType<typeof actionCreators.doChangeCurrentDay>
	| ReturnType<typeof actionCreators.doFlushProgramDays>
	| ReturnType<typeof actionCreators.doMoveItem>;
